export const BACK_DURATION = 30000;
export const IS_DEV = import.meta.env.DEV;
